(function(){'use strict';document.querySelectorAll('[data-edge-product-section]').forEach(function(root){var form=root.querySelector('.edge-product-form');if(!form)return;var isMembership=root.dataset.edgeMembership==='true',serviceType=root.dataset.edgeServiceType||'service',select=form.querySelector('[data-edge-variant-select]'),price=root.querySelector('[data-edge-product-price]'),button=form.querySelector('[data-edge-add-button]'),error=form.querySelector('[data-edge-form-error]'),organization=form.querySelector('[data-edge-organization]'),reapersGroup=form.querySelector('[data-edge-reapers-team-level]'),otherGroup=form.querySelector('[data-edge-other-team-level]'),teamLevelSelect=form.querySelector('[data-edge-team-level-select]'),teamLevelText=form.querySelector('[data-edge-team-level-text]');function updateTeamLevel(){if(!organization||!reapersGroup||!otherGroup||!teamLevelSelect||!teamLevelText)return;var isReapers=organization.value==='Chicago Reapers';reapersGroup.hidden=!isReapers;teamLevelSelect.disabled=!isReapers;teamLevelSelect.required=isReapers;otherGroup.hidden=isReapers;teamLevelText.disabled=isReapers;teamLevelText.required=!isReapers;if(isReapers){teamLevelText.value='';}else{teamLevelSelect.value='';}}if(organization){organization.addEventListener('change',updateTeamLevel);updateTeamLevel();}function update(){if(!select)return;var o=select.options[select.selectedIndex],ok=o&&o.dataset.available==='true';if(price&&o&&o.dataset.price)price.textContent=o.dataset.price;if(button){button.disabled=!ok;button.textContent=ok?(isMembership?'Add Membership to Cart':(serviceType==='profiling'?'Add Profiling to Cart':'Add Sharpening to Cart')):'Unavailable';}}if(select){select.addEventListener('change',update);update();}form.addEventListener('submit',function(e){if(!form.checkValidity()){e.preventDefault();form.reportValidity();if(error){error.hidden=false;error.textContent=isMembership?'Complete the required player fields before continuing.':'Review the required fields before continuing.';}return;}if(error)error.hidden=true;if(button){button.disabled=true;button.textContent='Adding…';}});});
function preselectWeekly(container){
  if(!container||container.dataset.edgeWeeklyDefaultApplied==='true')return false;
  var radio=container.querySelector('input[data-radio-type="selling_plan"]');
  if(!radio||radio.disabled)return false;
  container.dataset.edgeWeeklyDefaultApplied='true';
  if(!radio.checked)radio.click();
  return true;
}
function normalizeSubscriptionCopy(container){
  if(!container)return;
  var replacements={
    'One-time purchase':'Pay upfront for the 26-week season',
    'Deliver every week':'Billed weekly',
    'Delivers every week':'Billed weekly',
    'Auto-renews, skip or cancel anytime.':'Auto-renews weekly. Cancel anytime.',
    'Auto-renews, skip or cancel any time.':'Auto-renews weekly. Cancel anytime.'
  };
  var walker=document.createTreeWalker(container,NodeFilter.SHOW_TEXT);
  var node;
  while((node=walker.nextNode())){
    if(node.parentElement&&node.parentElement.closest('.edge-option-heading'))continue;
    var next=node.nodeValue;
    Object.keys(replacements).forEach(function(from){next=next.split(from).join(replacements[from]);});
    next=next.replace(/\s*USD\b/g,'');
    next=next.replace(/\$(\d+)\.00/g,function(_,amount){return '$'+amount;});
    next=next.replace(/Billed weekly,\s*\$(\d+)(?![\d.])/g,function(_,amount){return 'Billed weekly, $'+amount+'/week';});
    if(next!==node.nodeValue)node.nodeValue=next;
  }
  Array.prototype.slice.call(container.querySelectorAll('[aria-label]')).forEach(function(el){
    var value=el.getAttribute('aria-label')||'';
    value=value.replace(/\s*USD\b/g,'').replace(/\$(\d+)\.00/g,function(_,amount){return '$'+amount;});
    el.setAttribute('aria-label',value);
  });
}
function addGroupHeadings(container){
  if(!container)return;
  var upfrontInput=container.querySelector('input[data-radio-type="one_time_purchase"]');
  var weeklyInput=container.querySelector('input[data-radio-type="selling_plan"]');
  var upfrontGroup=upfrontInput&&upfrontInput.closest('.subscription_group');
  var weeklyGroup=weeklyInput&&weeklyInput.closest('.subscription_group');
  if(upfrontGroup&&!upfrontGroup.querySelector('.edge-option-heading--upfront')){
    var upfrontHeading=document.createElement('p');
    upfrontHeading.className='edge-option-heading edge-option-heading--upfront';
    upfrontHeading.textContent='Prepay & Save';
    upfrontGroup.insertBefore(upfrontHeading,upfrontGroup.firstChild);
  }
  if(weeklyGroup&&!weeklyGroup.querySelector('.edge-option-heading--weekly')){
    var weeklyHeading=document.createElement('p');
    weeklyHeading.className='edge-option-heading edge-option-heading--weekly';
    weeklyHeading.textContent='Billed weekly · Auto-renews';
    weeklyGroup.insertBefore(weeklyHeading,weeklyGroup.firstChild);
  }
  if(weeklyGroup){
    var groupName=weeklyGroup.querySelector('.group_name');
    if(groupName){groupName.hidden=true;groupName.setAttribute('aria-hidden','true');}
    var weeklyLabel=weeklyInput&&weeklyInput.closest('label');
    var weeklyCopy=weeklyLabel&&weeklyLabel.querySelector('.title_and_price_wrapper > span');
    var weeklyPrice=weeklyLabel&&weeklyLabel.querySelector('.in_widget_price');
    var rawPrice=weeklyInput&&weeklyInput.getAttribute('data-variant-price')||'';
    var amountMatch=rawPrice.match(/\$(\d+)/);
    var weeklyAmount=amountMatch?'$'+amountMatch[1]+'/week':'';
    if(weeklyCopy&&weeklyCopy.textContent.trim()!=='Billed weekly'){weeklyCopy.textContent='Billed weekly';}
    if(weeklyPrice&&weeklyAmount&&weeklyPrice.textContent.trim()!==weeklyAmount){
      weeklyPrice.textContent=weeklyAmount;
      weeklyPrice.classList.remove('shopify_subscriptions_app_block--hidden');
      weeklyPrice.setAttribute('aria-hidden','false');
    }
    if(weeklyInput&&weeklyAmount){weeklyInput.setAttribute('aria-label','Billed weekly, '+weeklyAmount);}
  }
  var policy=container.querySelector('.shopify_subscriptions_app_policy');
  if(policy&&policy.textContent.trim()!=='Auto-renews weekly. Cancel anytime.'){
    policy.textContent='Auto-renews weekly. Cancel anytime.';
  }
}
document.querySelectorAll('[data-edge-subscription-option]').forEach(function(container){
  normalizeSubscriptionCopy(container);
  addGroupHeadings(container);
  preselectWeekly(container);
  var observer=new MutationObserver(function(){
    normalizeSubscriptionCopy(container);
    addGroupHeadings(container);
    preselectWeekly(container);
  });
  observer.observe(container,{childList:true,subtree:true,characterData:true});
  window.setTimeout(function(){observer.disconnect();},8000);
});
})();
